import { Controller } from "stimulus"

export default class extends Controller {
  initialize(): void {
    const inputElement = this.element.querySelector('input') as HTMLInputElement;

    this.setAgreeToTermsClass(inputElement.checked)
  }

  update(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.setAgreeToTermsClass(target.checked)
  }

  setAgreeToTermsClass(checked: boolean): void {
    if (checked === true) {
      this.element.classList.add("is-active")
    } else {
      this.element.classList.remove("is-active")
    }
  }
}
